import React, { useEffect, useState } from 'react';

import Modal from '@/components/Modal';
import DeletePaymentModal from '@/components/Modals/DeletePaymentModal';
import LastPayMethodModal from '@/components/Modals/LastPayMethodModal';
import {
  useDeletePaymentMethod,
  useMakeDefaultMethod,
} from '@/Utils/stripeHooks/usePaymentMethods';
import useMediaQuery from '@/Utils/useMediaQuery';

const PaymentMethodCard = ({
  method,
  isLastPayMethod,
  isBooking,
  selected,
  setSelected,
  handleSelectedPayment,
}) => {
  const { last4, type, id, default: defaulMethod } = method;
  const isbank = type !== 'card';
  const isMobile = useMediaQuery('(max-width: 557px)');
  const deletePayment = useDeletePaymentMethod();

  const handleDeletePaymentMethod = (id: string) => {
    setIsOpen(false);
    deletePayment.mutate(id);
  };
  useEffect(() => {
    if (defaulMethod) {
      setSelected(id);
    }
  }, []);

  const defaultMethod = useMakeDefaultMethod();

  const handleMakePaymentDefault = (id: string) => {
    defaultMethod.mutate(id);
  };
  const [isOpen, setIsOpen] = useState(false);
  const handleCloseModal = () => {
    setIsOpen(false);
  };
  const handleOpenModal = () => {
    setIsOpen(true);
  };
  const formattedMonth = (month: number) => month.toString().padStart(2, '0');
  const formattedYear = (year: number): string => year.toString().slice(-2);

  return (
    <>
      <div className='flex px-2 py-6 md:p-8 border-solid border-black justify-between items-center rounded-lg border-1'>
        <div className='flex'>
          <div
            className='flex gap-2 md:gap-8 items-center'
            onClick={() => handleSelectedPayment(id)}
          >
            {isBooking && (
              <>
                <input
                  className='hidden pr-8'
                  type='radio'
                  name='payment_method_id'
                  value={selected}
                  checked={selected === id}
                  onChange={() => handleSelectedPayment(id)}
                />
                {selected === id ? (
                  <img
                    className=' cursor-pointer'
                    src='/icons/radio-checked.svg'
                    alt=''
                  />
                ) : (
                  <img
                    className=' cursor-pointer'
                    src='/icons/radio.svg'
                    alt=''
                  />
                )}
              </>
            )}
            {isbank ? (
              <img src='/icons/bank.svg' alt='' />
            ) : (
              <img src='/icons/card.svg' alt='' />
            )}
            <a href=''></a>
            <p className='text-14px md:text-16px m-0'>
              {!isMobile
                ? isbank
                  ? `************${last4}`
                  : `**** **** **** ${last4}`
                : `...${last4}`}
            </p>
          </div>
          {!isbank && (
            <p className='text-14px md:text-16px p-0 m-0 pl-10 md:pl-20'>
              {formattedMonth(method.exp_month)}/
              {formattedYear(method.exp_year)}
            </p>
          )}
        </div>
        {!isBooking && (
          <div className='flex gap-2 md:gap-10 items-center'>
            {defaulMethod ? (
              <p className='text-customBlue text-14px md:text-16px p-0 m-0'>
                <img src='/icons/check-mark.svg' alt='' /> Default
              </p>
            ) : (
              <button
                className='btn-transparent font-normal text-customBlue p-0 text-14px md:text-16px m-0 h-auto'
                onClick={() => handleMakePaymentDefault(id)}
                type='button'
              >
                Make Default
              </button>
            )}
            <button
              className='btn-transparent pr-0 font-normal text-customRed text-14px md:text-16px p-0 m-0 h-auto'
              onClick={handleOpenModal}
              type='button'
            >
              Delete
            </button>
          </div>
        )}
      </div>
      <Modal
        isOpen={isOpen}
        onRequestClose={handleCloseModal}
        shouldCloseOnOverlayClick={true}
        additionalStyles={{ maxWidth: '494px' }}
      >
        {isLastPayMethod ? (
          <LastPayMethodModal handleCloseModal={handleCloseModal} />
        ) : (
          <DeletePaymentModal
            handleCloseModal={handleCloseModal}
            handleDeletePaymentMethod={handleDeletePaymentMethod}
            id={id}
          />
        )}
      </Modal>
    </>
  );
};
export default PaymentMethodCard;
